enum LegislatorType {
  Representative = 'rep',
  Senator = 'sen',
}

export default LegislatorType;
